import { Translate } from "react-localize-redux";
import { Navbar } from "react-bootstrap";
import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";
import "../../../styles/app.scss";
import ThreeDots from "../../../assets/images/icons/three-dots.svg";
import "../../../styles/header.scss";
import MenuSheet from "../../menuSheet/MenuSheet";
import WelcomeSheet from "../../welcomeSheet/WelcomeSheet";
import { ReactComponent as ArrowBack } from "../../../assets/common/arrow-back.svg";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { useEffect, useRef } from "react";
import { SearchBox } from "wallet-elementkit/dist/components";

import { useAppSelector } from "../../../store/hooks";
import { selectUser } from "../../../store/features/user";
import ConditionalWrapper from "../ConditionalWrapper";
import { configFallback } from "wallet-elementkit/dist/constants/master";

function useOutsideAlerter(ref, dotRef, isMenuOpen, closeNav, setMenuOpen) {
	useEffect(() => {
		/**
		 * Alert if clicked on outside of element
		 */

		function handleClickOutside(event) {
			if (
				ref.current &&
				!ref.current.contains(event.target) &&
				isMenuOpen &&
				dotRef.current &&
				!dotRef.current.contains(event.target)
			) {
				closeNav();
				setMenuOpen(!isMenuOpen);
			}
		}
		// Bind the event listener
		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [ref, dotRef, isMenuOpen]);
}
const HeaderMobile = (props) => {
	const history = useHistory();
	const userMeta = useAppSelector(selectUser);
	const wrapperRef = useRef(null);
	const dotRef = useRef(null);
	useOutsideAlerter(
		wrapperRef,
		dotRef,
		props.isMenuOpen,
		props.closeNav,
		props.setMenuOpen
	);
	return (
		<div>
			<div id="myNav" className="overlay" ref={wrapperRef}>
				<div className="def-pad overlay-content">
					{props.config.headerMenu?.length ? (
						<div className="menu-items">
							{props.config.headerMenu.map((item) => (
								<a
									href={item.link}
									target="_blank"
									rel="noreferrer"
									className="single-menu-item customizable-text"
								>
									{item.text}
								</a>
							))}
						</div>
					) : null}
					{props.config.headerButtonUrl ? (
						<a
							href={
								props.config.headerButtonUrl.includes("http")
									? props.config.headerButtonUrl
									: `http://${props.config.headerButtonUrl}`
							}
							rel="noreferrer"
							target="_blank"
						>
							<BaseButton
								type="primary"
								size="small"
								className="header-button"
								height={45}
								// onClickAction={logout}
								onClickAction={() => {
									props.changeNav();
								}}
								backgroundColor={props.config.headerButtonBackgroundColor}
							>
								<span
									className="s7"
									style={{
										color: props.config.headerButtonTextColor,
									}}
								>
									{props.config.ctaText ? (
										props.config.ctaText
									) : (
										<Translate id="visitWebsite" />
									)}
								</span>
							</BaseButton>
						</a>
					) : null}
					{props.config.contactEmail ? (
						<BaseButton
							type="secondary"
							size="small"
							className="header-button"
							styles={{
								borderColor: props.config.primaryColor,
							}}
							height={45}
							onClickAction={() => {
								props.handleContact();
								props.changeNav();
							}}
						>
							<span
								className="s7"
								style={{
									color: props.config.primaryColor,
								}}
							>
								<Translate id="contact" />
							</span>
						</BaseButton>
					) : null}
					<div
						className="account-modal-icon-container"
						onClick={() => {
							props.setAccountModalOpen((prevState) => !prevState);
							props.changeNav();
						}}
					>
						<BaseButton
							className="account-button"
							type="primary"
							size="small"
							styles={{
								borderColor: props.config.primaryColor,
							}}
							height={45}
							loading={false}
						>
							<span className="s7">
								<Translate id="account" />
							</span>
						</BaseButton>
					</div>
				</div>
			</div>
			<Navbar id="myNavbar" expand="lg" fixed="top">
				<div
					className="flex-row main-header-mobile"
					style={{
						backgroundColor: props.config.headerBackgroundColor,
					}}
				>
					{props.backButton.backButtonEnabled ? (
						<ConditionalWrapper
							condition={
								!props.backButton.onClickAction &&
								props.backButton.redirectUrl != null
							}
							wrapper={(children) => (
								<Link
									to={
										!props.backButton.onClickAction &&
										props.backButton.redirectUrl
											? props.activeLanguage
												? `/${props.activeLanguage.code}/${props.backButton.redirectUrl}`
												: `/en/${props.backButton.redirectUrl}/}`
											: props.activeLanguage
											? `/${props.activeLanguage.code}/profile/${props.userMeta.user.username}/`
											: `/en/profile/${props.userMeta.user.username}/`
									}
								>
									{children}
								</Link>
							)}
							children={
								<BaseButton
									type="secondary"
									size="small"
									loading={false}
									height={35}
									width={175}
									onClickAction={props.backButton.onClickAction}
									className="back-button"
								>
									<div className="flex-row jc-sb">
										<ArrowBack className="arrow-back customizable-icon" />
										<Translate
											id={props.backButton.buttonTextKey || "backToHomepage"}
										/>
									</div>
								</BaseButton>
							}
						/>
					) : (
						<a
							href={
								(!props.config.logoRedirectUrl ||
									props.config.logoRedirectUrl ===
										configFallback.logoRedirectUrl) &&
								props.config.website
									? props.config.website
									: props.config.logoRedirectUrl.includes("http")
									? props.config.logoRedirectUrl
									: `http://${props.config.logoRedirectUrl}`
							}
							target="_blank"
							rel="noreferrer"
						>
							<img
								alt="Verified"
								style={{ cursor: "pointer" }}
								src={props.config.logoLink}
								className="org-logo"
							/>
						</a>
					)}
					{!props.backButton.backButtonEnabled && props.userMeta.logged && (
						<SearchBox
							historyPush={history.push}
							activeLanguage={props.activeLanguage}
							translate={props.translate}
							isMobile={true}
							addTranslation={props.addTranslation}
							isLogged={userMeta.logged}
						></SearchBox>
					)}
					{props.config.contactEmail ||
					props.config.headerButtonUrl ||
					props.config.socials.length > 0 ? (
						<img
							alt="verified"
							ref={dotRef}
							src={ThreeDots}
							onClick={props.changeNav}
						/>
					) : null}
				</div>
			</Navbar>
			{props.accountModalOpen &&
				(props.userMeta.logged ? (
					<MenuSheet
						isMobile={true}
						sheetOpen={props.accountModalOpen}
						userMeta={props.userMeta}
						onClose={props.handleModalClose}
						translate={props.translate}
						config={props.config}
					/>
				) : (
					<WelcomeSheet
						isMobile={true}
						config={props.config}
						sheetOpen={props.accountModalOpen}
						onClose={props.handleModalClose}
					/>
				))}
		</div>
	);
};

export default HeaderMobile;
